<template>
    <div class="main">
        <b-card>
            <b-card-body>
                <b-row class="mb-2">
                    <b-col md="12" class="d-flex justify-content-end">
                        <b-button v-if="IsAdmin()" variant="primary" @click="showAddLeaveTypesModal">
                            <feather-icon icon="PlusIcon" class="mr-50" />
                            New Leave Types
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="2" sm="4" class="my-1">
                        <b-form-group class="mb-0">
                            <label class="d-inline-block text-sm-left mr-50">Per page</label>
                            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                                class="w-50" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
                        <b-button variant="outline-danger" size="sm" @click="clearFilters">
                            Clear Filters
                        </b-button>
                    </b-col>

                    <b-col cols="12">
                        <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
                            :items="filteredLeaveTypes" :fields="leavetypes_fields" @filtered="onFiltered">

                            <!-- Filter input for Title -->
                            <template #head(title)="scope">
                                <div class="d-flex flex-column">
                                    <span @click="toggleSort('title')" style="cursor: pointer">Title</span>
                                    <b-form-input v-model="filters.title" placeholder="Filter by Title"
                                        @input="applyFilters" size="sm" />
                                </div>
                            </template>

                            <!-- Filter input for Abbreviation -->
                            <template #head(abbreviation)="scope">
                                <div class="d-flex flex-column">
                                    <span @click="toggleSort('abbreviation')"
                                        style="cursor: pointer">Abbreviation</span>
                                    <b-form-input v-model="filters.abbreviation" placeholder="Filter by Abbreviation"
                                        @input="applyFilters" size="sm" />
                                </div>
                            </template>

                            <!-- Filter input for Color -->
                            <template #head(color)="scope">
                                <div class="d-flex flex-column">
                                    <span @click="toggleSort('color')" style="cursor: pointer">Color</span>
                                    <b-form-input v-model="filters.color" placeholder="Filter by Color"
                                        @input="applyFilters" size="sm" />
                                </div>
                            </template>

                            <!-- Filter dropdown for Status -->
                            <template #head(status)="scope">
                                <div class="d-flex flex-column">
                                    <span @click="toggleSort('status')" style="cursor: pointer">Status</span>
                                    <b-form-select v-model="filters.status" :options="statusOptionsWithPlaceholder"
                                        @change="applyFilters" size="sm" />
                                </div>
                            </template>

                            <template #cell(status)="data">
                                <b-badge :variant="statusVariants[data.item.status]">
                                    {{ data.item.status }}
                                </b-badge>
                            </template>
                            <template #cell(actions)="data">

                                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                                    <template #button-content>
                                        <feather-icon icon="MoreVerticalIcon" size="16"
                                            class="align-middle text-body" />
                                    </template>
                                    <b-dropdown-item :disabled="!IsAdmin()" @click="leaveAction('ACTIVATE', data.item, data.item.id)">
                                        <feather-icon icon="CheckIcon" />
                                        <span class="align-middle ml-50">Activate</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item :disabled="!IsAdmin()" @click="leaveAction('DEACTIVATE', data.item, data.item.id)">
                                        <feather-icon icon="XIcon" />
                                        <span class="align-middle ml-50">Deactivate</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="showViewLeaveTypesModal(data.item)">
                                        <feather-icon icon="EyeIcon" />
                                        <span class="align-middle ml-1">View</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item :disabled="!IsAdmin()" @click="showEditLeaveTypesModal(data.item)">
                                        <feather-icon icon="EditIcon" />
                                        <span class="align-middle ml-1">Edit</span>
                                    </b-dropdown-item>
                                    <!-- <b-dropdown-item @click="confirmDeleteLeaveTypes(data.item.id)">
                                        <feather-icon icon="TrashIcon" />
                                        <span class="align-middle ml-1">Delete</span>
                                    </b-dropdown-item> -->
                                </b-dropdown>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-center mb-1">
                            <div class="d-flex justify-content-center mb-1" v-if="loading">
                                <b-spinner variant="success" label="Spinning"
                                    style="width: 3rem; height: 3rem"></b-spinner>
                            </div>
                        </div>

                    </b-col>


                    <b-col cols="12">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center"
                            size="sm" class="my-0" />
                            <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
                    </b-col>
                </b-row>

                <!-- Modal for adding a new Leave Types-->
                <b-modal ref="modalAddLeaveTypes" id="modal-add-leave-types" title="Add New Leave Types"
                    @hide="resetForm" hide-footer centered>
                    <validation-observer ref="addLeaveTypesForm" v-slot="{ invalid, validate }">
                        <b-form @submit.prevent="validate().then((success) => success && addNewLeaveTypes())">
                            <b-form-group label="Title*" label-for="title">
                                <validation-provider name="Title" rules="required" v-slot="{ errors }">
                                    <b-form-input id="title" v-model="newLeaveTypes.title" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Abbreviation*" label-for="abbreviation">
                                <validation-provider name="Abbreviation" rules="required" v-slot="{ errors }">
                                    <b-form-input id="abbreviation" v-model="newLeaveTypes.abbreviation" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Color*" label-for="color">
                                <validation-provider name="Color" rules="required" v-slot="{ errors }">
                                    <!-- <b-form-input id="color" v-model="newLeaveTypes.color" /> -->
                                    <b-form-select id="color" v-model="newLeaveTypes.color" :options="colorOptions" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="Balance*" label-for="balance">
                                <validation-provider name="Balance" rules="required|numeric" v-slot="{ errors }">
                                    <b-form-input id="balance" v-model="newLeaveTypes.balance" type="number"  min="1"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="Status*" label-for="status">
                                <validation-provider name="Status" rules="required" v-slot="{ errors }">
                                    <b-form-select id="status" v-model="newLeaveTypes.status"
                                        :options="statusOptions" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-button type="submit" variant="primary" :disabled="invalid">
                                Add Leave Types
                            </b-button>
                        </b-form>
                    </validation-observer>
                </b-modal>

                <!-- Modal for editing a Leave Types -->
                <b-modal ref="modalEditLeaveTypes" id="modal-edit-leave-types" title="Edit Leave Types" hide-footer
                    centered>
                    <validation-observer ref="editLeaveTypesForm" v-slot="{ invalid, validate }">
                        <b-form @submit.prevent="validate().then((success) => success && updateLeaveTypes())">
                            <b-form-group label="Title" label-for="editTitle">
                                <validation-provider name="Title" rules="required" v-slot="{ errors }">
                                    <b-form-input id="editTitle" v-model="editLeaveTypes.title" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Abbreviation" label-for="editAbbreviation">
                                <validation-provider name="Abbreviation" rules="required" v-slot="{ errors }">
                                    <b-form-input id="abbreviation" v-model="editLeaveTypes.abbreviation" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Color" label-for="editColor">
                                <validation-provider name="Color" rules="required" v-slot="{ errors }">
                                    <!-- <b-form-input id="color" v-model="editLeaveTypes.color" /> -->
                                    <b-form-select id="color" v-model="editLeaveTypes.color" :options="colorOptions" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="Balance" label-for="editBalance">
                                <validation-provider name="Balance" rules="required|numeric" v-slot="{ errors }">
                                    <b-form-input id="balance" v-model="editLeaveTypes.balance" type="number" min="1"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="Status" label-for="editStatus">
                                <validation-provider name="Status" rules="required" v-slot="{ errors }">
                                    <b-form-select id="editStatus" v-model="editLeaveTypes.status"
                                        :options="statusOptions" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-button type="submit" variant="primary" :disabled="invalid">
                                Save Changes
                            </b-button>
                        </b-form>
                    </validation-observer>
                </b-modal>

                <!-- Modal for viewing a Leave Types -->
                <b-modal ref="modalViewLeaveTypes" id="modal-view-gps" title="View Leave Types" hide-footer centered>
                    <b-form>

                        <b-form-group label="Title" label-for="viewTitle">
                            <b-form-input id="viewTitle" v-model="viewLeaveTypes.title" readonly />
                        </b-form-group>
                        <b-form-group label="Abbreviation" label-for="viewAbbreviation">
                            <b-form-input id="viewAbbreviation" v-model="viewLeaveTypes.abbreviation" readonly />
                        </b-form-group>
                        <b-form-group label="Color" label-for="viewColor">
                            <b-form-input id="viewColor" v-model="viewLeaveTypes.color" readonly />
                        </b-form-group>
                        <b-form-group label="Balance" label-for="viewBalance">
                            <b-form-input id="viewBalance" v-model="viewLeaveTypes.balance" readonly />
                        </b-form-group>
                        <b-form-group label="Status" label-for="viewStatus">
                            <b-form-input id="viewStatus" v-model="viewLeaveTypes.status" readonly />
                        </b-form-group>
                    </b-form>
                </b-modal>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { BTable, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BFormDatepicker, BInputGroupAppend, BButton, BCard, BForm, BCardBody, BDropdown, BModal, BDropdownItem, BSpinner, BBadge } from 'bootstrap-vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";

extend('required', {
    ...required,
    message: 'This field is required'
});
extend('numeric', {
    ...numeric,
    message: 'This field must be a number'
});

export default {
    components: {
        BCard,
        BCardBody,
        BTable,
        BModal,
        BForm,
        BRow,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BDropdown,
        BDropdownItem,
        ValidationObserver,
        BBadge,
        ValidationProvider,
        BSpinner,
        BFormDatepicker,

    },
    data() {
        return {
            perPage: 5,
            pageOptions: [3, 5, 10],
            totalRows: 1,
            currentPage: 1,
            filter: null,
            filters: {
                title: '',
                abbreviation: '',
                color: '',
                status: '', // Initially empty to allow any status
            },
            statusOptionsWithPlaceholder: [
                { value: '', text: 'All Statuses' }, // Allow clearing the filter
                ...["ACTIVATE", "DEACTIVATE"].map(status => ({ value: status, text: status }))
            ],
            filterOn: ['title', 'abbreviation', 'color', 'balance', 'status'],
            leavetypes_fields: [
                { key: "title", label: "Title", sortable: true },
                { key: "abbreviation", label: "Abbreviation", sortable: true },
                { key: "color", label: "Color", sortable: true },
                { key: "balance", label: "Balance", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "actions", label: "Actions" },
            ],
            colorOptions: ["BLUE", "GREEN", "RED", "YELLOW", "BLACK"],
            statusOptions: ["ACTIVATE", "DEACTIVATE"],
            statusVariants: {
                ACTIVATE: 'success',
                DEACTIVATE: 'danger'
            },

            newLeaveTypes: {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            },
            viewLeaveTypes: {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            },
            editLeaveTypes: {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            },


        };
    },
    computed: {
        ...mapGetters('leavetypeModule', {
            leavetypes: 'leavetypes',
            loading: 'loading',
        }),
        filteredLeaveTypes() {
            const filtered = this.leavetypes.filter(type => {
        const matchesTitle = !this.filters.title || type.title.toLowerCase().includes(this.filters.title.toLowerCase());
        const matchesAbbreviation = !this.filters.abbreviation || type.abbreviation.toLowerCase().includes(this.filters.abbreviation.toLowerCase());
        const matchesColor = !this.filters.color || type.color.toLowerCase().includes(this.filters.color.toLowerCase());
        const matchesStatus = !this.filters.status || type.status === this.filters.status;

        return matchesTitle && matchesAbbreviation && matchesColor && matchesStatus;
    });

    // Sort alphabetically by title
    return filtered.sort((a, b) => {
        const titleA = a.title?.toLowerCase() || '';
        const titleB = b.title?.toLowerCase() || '';
        return titleA.localeCompare(titleB);
    });
        }
    },
    methods: {
        ...mapActions('leavetypeModule', [
            'getLeaveTypeListAction',
            'removeLeaveTypeAction',
            'addLeaveTypeAction',
            'updateLeaveTypeAction'
        ]),

        showAddLeaveTypesModal() {
            this.$refs.modalAddLeaveTypes.show();
        },

        resetForm() {
            this.newLeaveTypes = {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            };
            this.editLeaveTypes = {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            };
            this.viewLeaveTypes = {
                title: null,
                abbreviation: null,
                color: null,
                balance: null,
                status: null,
            };
        },

        success(message) {
            this.$swal({
                title: "Leave Type Status Updated!",
                text: message,
                icon: "success",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
            });
        },

        async leaveAction(status, item, id) {
            const result = await this.$swal({
                title: "Are you sure?",
                text: "You will not be able to revert your changes!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, update status!",
                cancelButtonText: "Cancel",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            });

            if (result.isConfirmed) {
                const payload = {
                    leaveTypeId: item.leaveTypeId,
                    title: item.title,
                    abbreviation: item.abbreviation,
                    color: item.color,
                    balance: item.balance,
                    status: status
                }

                try {
                    await this.updateLeaveTypeAction(payload);
                    this.success();
                    await this.getLeaveTypeListAction();
                } catch (updateError) {
                    console.error("Error updating Leave Type:", updateError);
                    await this.$swal({
                        title: "Error",
                        text: "An error occurred while updating the Leave Type.",
                        icon: "error",
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                    });
                }
            }
        },

        async addNewLeaveTypes() {
            this.loading = true;
            const loader = Swal.fire({
                title: 'Processing...',
                text: 'Please wait while the Leave Types is being added',
                allowOutsideClick: () => !Swal.isLoading(),
                showConfirmButton: false,
                showCancelButton: false,
                buttonsStyling: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            try {
                await this.addLeaveTypeAction(this.newLeaveTypes);
                loader.close();
                this.$bvModal.hide('modal-add-leave-types');
                this.success('Leave Types added successfully.');
                this.getLeaveTypeListAction();
                this.resetForm();
            } catch (error) {
                loader.close();
                //this.error(error.response.data);
                Swal.fire({
                    title: 'Error!',
                    text: error.response.data.message || 'An error occurred while adding leave types.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            } finally {
                this.loading = false;
            }
        },


        showViewLeaveTypesModal(item) {
            this.viewLeaveTypes = { ...item };
            this.$refs.modalViewLeaveTypes.show();
        },
        showEditLeaveTypesModal(item) {
            this.editLeaveTypes = { ...item };
            this.$refs.modalEditLeaveTypes.show();
            this.getLeaveTypeListAction();
        },


        async updateLeaveTypes() {
            this.loading = true;
            const loader = Swal.fire({
                title: 'Processing...',
                text: 'Please wait while the Leave Types is being updated',
                allowOutsideClick: () => !Swal.isLoading(),
                showConfirmButton: false,
                showCancelButton: false,
                buttonsStyling: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            try {
                await this.updateLeaveTypeAction(this.editLeaveTypes);
                loader.close();
                this.$bvModal.hide('modal-edit-leave-types');
                this.success('Leave Types updated successfully.');
                this.loading = false;
                this.resetForm();
                this.getLeaveTypeListAction();
            } catch (error) {
                loader.close();
                this.error(error.response.data);
                this.loading = false;
                this.getLeaveTypeListAction();
            } finally {
                this.getLeaveTypeListAction();
                this.loading = false;
            }
        },
        async confirmDeleteLeaveTypes(leavetypeId) {
            const confirmation = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            });

            if (confirmation.isConfirmed) {
                this.deleteLeaveTypes(leavetypeId);
            } else if (confirmation.dismiss === Swal.DismissReason.cancel) {
                Swal.fire({
                    title: 'Cancelled',
                    text: 'Your Leave Types is safe :)',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                });
            }
        },

        async deleteLeaveTypes(leavetypeId) {
            const loader = Swal.fire({
                title: 'Processing...',
                text: 'Please wait while the Leave Types is being deleted',
                allowOutsideClick: () => !Swal.isLoading(),
                showConfirmButton: false,
                showCancelButton: false,
                buttonsStyling: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            try {
                await this.removeLeaveTypeAction(leavetypeId);
                loader.close();
                Swal.fire({
                    title: 'Deleted!',
                    text: 'The Leave Types has been deleted.',
                    icon: 'success',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                });
                this.resetForm();
                this.getLeaveTypeListAction();
            } catch (error) {
                loader.close();
                this.error(error.response.data);
                this.getLeaveTypeListAction();
            } finally {
                this.loading = false;
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        applyFilters() {
            // Reset to the first page when filters are applied
            this.currentPage = 1;
        },
        clearFilters() {
            // Reset each filter property to its initial state
            this.filters = {
                title: '',
                abbreviation: '',
                color: '',
                status: '' 
            };
            // Optionally, you can reset the page to the first page
            this.currentPage = 1;
        }
    },
    async mounted() {
        this.getLeaveTypeListAction().then(() => {
            this.totalRows = this.leavetypes.length;
        });
    },
    setup(){
    return {
      IsAdmin
    }
  }
};
</script>

<style scoped>
/* Add your existing styles here */
</style>